export const randomNumbersGenerator = (numbersAmount) => {
  if (numbersAmount < 1) {
    throw new Error('numbersAmount must be grather than 0')
  }

  if (numbersAmount === 1) {
    return Math.floor(Math.random() * 9) + 1
  }

  const multiple = '0'.repeat(numbersAmount - 1)

  return (
    Math.floor(Math.random() * Number('9' + multiple)) +
    Number('1' + multiple)
  )
}
